import {Component, Input} from '@angular/core';
import {CompetitorResults, RaceSettings} from "@model";

@Component({
  selector: 'app-live-results-mobile-item',
  templateUrl: './live-results-mobile-item.component.html',
  styleUrls: ['./live-results-mobile-item.component.scss']
})
export class LiveResultsMobileItemComponent {
  @Input() hasBorderBottom: boolean = true;
  @Input() liveResult?: CompetitorResults = undefined;
  @Input() isRoundRace?: boolean = false;
  @Input() firstCompetitorResults: CompetitorResults | undefined = undefined;
  @Input() measurementType: number | undefined = undefined;
  @Input() gender?: number;
  @Input() category?: number;
  @Input() raceSettings: RaceSettings | undefined;

}
